import axios from "axios";

import { tr, getLang } from "@/lib/i18n";
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use((cfg) => { cfg.headers = cfg.headers || {}; if (!cfg.headers["X-Lang"]) cfg.headers["X-Lang"] = getLang(); return cfg; });

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;
export const refreshSession = () => {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
};

api.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config;
  const url = cfg?.url || "";
  if (err.response?.status === 401 && cfg && !cfg._retry && !NO_RETRY.includes(url)) {
    cfg._retry = true;
    try {
      await refreshSession();
      return api(cfg);
    } catch {
      window.dispatchEvent(new Event("sr-logout"));
    }
  }
  return Promise.reject(err);
});

export function apiError(e, fallback = tr("Si è verificato un errore. Riprova.")) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d.msg === "string" ? d.msg : String(d);
}

export async function calcEnv(p, e = p.env || {}) {
  const { data } = await api.post("/calc/environment", {
    region: p.region, province: p.province, altitude: Number(p.altitude) || 0,
    building_height: Number(p.building_height) || 8, exposure: e.exposure || "II",
    pitch: 0, lat: p.lat, lng: p.lng,
    wind_zone: e.wind_zone_override ? Number(e.wind_zone_override) : null, snow_zone: e.snow_zone_override || null,
  });
  return { ...e, ...data, manual: false };
}
